export class ContaParcela {

  contaParcelaId: number = 0;

  tipoConta: number = 0;

  contaParcelaTipo: number = 0;

  contaContabilDebitoId: number = 0;

  contaContabilCreditoId: number = 0;

  descricao: string = '';

  valorParcela: number = 0;

  dataCriacao: Date = new Date();

  dataVencimento: Date = new Date();

  valorAteVenc: number = 0;

  valorMultaCalculada: number = 0;

  valorMoraDia: number = 0;

  valorMoraCalculada: number = 0;

  statusPagamento: number = 0; //0- A pagar, 1- Pago, 2- Cancelado, 3- Estornado, 4 - Retido

  dataPagamento: Date = new Date();

  valorPagamento: number = 0;

  observacaoPagamento: string = '';

  valorQueFicaraAtivo: number = 0;

  tipoPagamento: TipoPagamento = TipoPagamento.Dinheiro;

  caixaMovimentoId: number = 0;

  boletoId: number = 0;

  nossoNumero: number = 0;

  valorBruto: number = 0;

  valorLiquido: number = 0;

  saldo: number = 0;

  nfseId: number = 0;

  nfeId: number = 0;

  nfseNumero: string = "";

  nfeNumero: number = 0;

  adiantamentoContaId: number = 0;

  operacaoContabilId: number = 0;

  saguiClienteId: number = 0;

  contaId: number = 0;

  selected: boolean = false;

  caixaId: number = 0;

  numeroParcelas: number = 1;

  numeroDoComprovanteDeVenda: string = '';

  codigoAutenticacao : string = '';

  contaCorrenteVendaId : number = 0

  contaCorrenteTerminalCartaoId: number = 0;

  contaCorrenteTerminalId: number = 0;

  valorJurosPago: number = 0;

  valorMultaPago: number = 0;

  valorDescontoPago: number = 0;

  documentoFiscal: number = 1;

  adquirenciaId: number = 0; // utilizado para pagamentos com cartão no conta-parcela baixa componente (contaBaixaForm)
}

export enum TipoPagamento {
  "Dinheiro" = 0,
  "Debito" = 1,
  "Credito" = 2,
  "Boleto" = 3,
  "Transferencia" = 4,
  "Cheque" = 5,
  "Vale Refeicao" = 6,
  "Banco" = 7,
  "Prestacao de Conta" = 8,
  "Devolução" = 9,
  "Transferencia Entre Caixas" = 10,
  "Pix" = 11,
  "Pix QR Code" = 12,
  "BolePix" = 13
}
